import React, { memo } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { AboutUs } from './pages/AboutUs';
import { MemoryCareTogether } from './pages/MemoryCareTogether';
export function App() {
  return <Router data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<LandingPage data-id="element-3" />} data-id="element-2" />
        <Route path="/about" element={<AboutUs data-id="element-5" />} data-id="element-4" />
        <Route path="/memory-care-together" element={<MemoryCareTogether data-id="element-7" />} data-id="element-6" />
      </Routes>
    </Router>;
}